import script from "./LiveResultsView.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveResultsView.vue?vue&type=script&setup=true&lang=js"

import "./LiveResultsView.vue?vue&type=style&index=0&id=043e5d91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043e5d91"]])

export default __exports__